export function scroll() {
    const resultsSection = document.querySelector('.sb-results');
    if (resultsSection) {
        resultsSection.scrollIntoView(true);
    }
}



// WEBPACK FOOTER //
// ./src/client/utils/scrollHelper.js